<template lang="pug">
  aside.event-side-nav
    div.navs
      a.nav(v-for="nav in navigators" :key="nav.key" :class="{active: nav.key === $route.name}" @click.prevent="toRoute(nav)")
        span(:class="{lock: nav.key !== 'EventGeneral' && !event.hasRule}") {{nav.name}}
          img(src="../assets/img/event/lock.png" v-if="nav.key !== 'EventGeneral' && !event.hasRule")
        div.bar
    div.footer
      easy-footer
</template>
<script>
import {eventNavigators} from '@index/config/config'
import EasyFooter from '../components/EasyFooter'
import _ from 'lodash'
export default {
  name: 'eventSideBar',
  components: {
    EasyFooter
  },
  data () {
    return {
      navigators: _.cloneDeep(eventNavigators)
    }
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  created () {},
  computed: {},
  methods: {
    guide (nav) {
      if (nav.auth && !this.event.hasRule) {
        this.$router.push({
          name: 'EventCharge'
        })
        return false
      } else {
        return true
      }
    },
    toRoute (nav) {
      if (this.guide(nav)) {
        this.$router.push({name: nav.key})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .event-side-nav{
    min-width: 208px;
    margin-right: 20px;
    position: relative;
    .footer{
      position: absolute;
      left: 0;
      bottom: 0;
    }
    .navs{
      background-color: #ffffff;
      border-radius: 4px;
      padding: 30px 0;
    }
    .nav{
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      height: 40px;
      margin: 8px 0;
      span{
        margin-left: 50px;
        color: #333;
        &:hover{
          color: #333;
        }
        &.lock{
          color: #ccc;
        }
        position: relative;
        img{
          position: absolute;
          top: 50%;
          right: -20px;
          transform: translate(0, -50%);
        }
      }
      .bar{
        width: 4px;
        height: 40px;
      }
      &.active{
        background-color: rgba(57,137,203,0.1);
        span{
          color: #3989cb;
        }
        .bar{
          background-color: #3989cb;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventCenter/EventSideNav.vue